<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="40%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="1" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="供应商名称:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="rfqSupplierName" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.rfqSupplierName" placeholder="供应商名称"></el-input> -->
                        {{dataForm.rfqSupplierName}}
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="项目经验:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="rfqSupplierExpierence" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.rfqSupplierExpierence" placeholder="项目经验"></el-input>
                         -->
                        {{dataForm.rfqSupplierExpierence}}
                    </el-form-item>
                </el-descriptions-item>
                <!-- <el-descriptions-item label="主邮箱:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="rfqVendorMail" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.rfqVendorMail" placeholder="主邮箱"></el-input>
                    </el-form-item>
                </el-descriptions-item> -->
                <el-descriptions-item label="联系人邮箱:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="rfqContractMail" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.rfqContractMail" placeholder="联系人邮箱"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="类型:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="rfqSupplierType" style="margin-bottom: 0;">
                        <!-- <el-select v-model="dataForm.rfqSupplierType" placeholder="请选择" clearable>
                            <el-option v-for="item in SUPPLY_TYPE_VALUE" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select> -->
                        {{SUPPLY_TYPE_VALUE(dataForm.rfqSupplierType)}}
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="回复状态:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="rfqSupplerReplyStatus" style="margin-bottom: 0;">
                        <el-select v-model="dataForm.rfqSupplierReplyStatus" placeholder="请选择" clearable>
                            <el-option v-for="item in QUOTATION_STATUS_VALUE" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="view.visible = false">
            <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
        </el-button>
        <el-button size="small" type="primary" plain @click="dataFormSubmit()">
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
        </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    getRfqSupplierById,
    createRfqSupplier,
    editRfqSupplier,
} from "@/controller/rfq";
import {
    QUOTATION_STATUS_VALUE,
    getSUPPLY_TYPE_VALUE
} from '@/utils/const'
export default {
    data() {
        return {
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            viewData: {},
            dataForm: {
                id: 0,
                rfqSupplierName: '',
                userMail: '',
                rfqSupplierExpierence: '',
                rfqSupplerType: 0,
                rfqSupplierReplyStatus: '',
                rfqContractMail: '',
                rfqId: '',
            },
            QUOTATION_STATUS_VALUE: QUOTATION_STATUS_VALUE,
            SUPPLY_TYPE_VALUE: getSUPPLY_TYPE_VALUE,
            // 开始
            dataRule: {
                // type: [
                //     {
                //         required: true,
                //         message: "编码类型不能为空",
                //         trigger: "blur",
                //     },
                // ],
            },
        };
    },
    methods: {
        init(id) {
            console.log('init')
            this.userInfo = this.$store.state.user.userInfo
            this.dataForm.id = id || 0;
            // this.dataForm.rfqId = rfqId;
            this.view.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    console.log('getRfqSupplierById')
                    getRfqSupplierById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                    // 获取供应商状态

                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let supplierParams = {
                        id: this.dataForm.id || undefined,
                        userMail: this.dataForm.userMail,
                        rfqSupplierName: this.dataForm.rfqSupplierName,
                        rfqVenderLoginName: this.dataForm.rfqVenderLoginName,
                        rfqSupplierExpierence: this.dataForm.rfqSupplierExpierence,
                        rfqSupplierType: this.dataForm.rfqSupplierType,
                        rfqSupplierReplyStatus: this.dataForm.rfqSupplierReplyStatus,
                        rfqContractMail: this.dataForm.rfqContractMail,
                        rfqId: this.dataForm.rfqId,
                    };
                    if (this.dataForm.id) {
                        editRfqSupplier(supplierParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshSupplierDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        createRfqSupplier(supplierParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshSupplierDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        getStyle() {
            return 'width: 100px; text-align: right'
        },
        getStyle2() {
            // return 'width: 392px;'
        }
    },
};
</script>
